import React, { useContext, useEffect, useMemo } from 'react';
import { Alert } from 'react-bootstrap';

import { Ctx } from 'components/CtxFormFields/CtxInputs';

function ScaleFairbanks() {
  const formContext = useContext(Ctx);
  const { setEnabledSave } = formContext.values;

  useEffect(() => {
    setEnabledSave(true);
  }, []);
  return (
    <Ctx.Provider
      // @ts-ignore
      value={useMemo(() => ({ values: {}, onChange: () => {} }), [])}
    >
      <Alert variant="warning">No configuration needed</Alert>
    </Ctx.Provider>
  );
}

export default ScaleFairbanks;
